import React from 'react'
import Loaderitself from "react-loader-spinner";

export default function Loader() {

    return (
        <div className="w-full relative" style={{ height: window.innerHeight }}>
            <div className="absolute centerAbsolute">
                <Loaderitself
                    type="Grid"
                    color="#000"
                    height={100}
                    width={100}
                />
            </div>
        </div>
    )
}
